import React, { useState, useEffect } from 'react';

// Components
import { Login, Validate2FACodeView } from '../../';

// Assets
import { Auth, getAuth, MultiFactorError } from 'firebase/auth';
import { TabView, SceneMap } from 'react-native-tab-view';
import { Dimensions, StatusBar } from 'react-native';

const initialLayout = { width: Dimensions.get('window').width };

export interface LoginContainerProps {
  onSuccess: () => void;
}

export interface FirstRouteProps {
  auth: Auth;
  display2FAValidation: (auth: Auth, error: any) => void;
  onSuccess: () => void;
}
const FirstRoute = ({
  auth,
  display2FAValidation,
  onSuccess,
}: FirstRouteProps) => {
  return (
    <Login
      auth={auth}
      display2FAValidation={display2FAValidation}
      onSuccess={onSuccess}
    />
  );
};

export interface SecondRouteProps {
  auth: Auth;
  error: MultiFactorError | undefined;
}
const SecondRoute = ({ auth, error }: SecondRouteProps) => {
  return <Validate2FACodeView auth={auth} error={undefined} />;
};

export function LoginContainer({ onSuccess }: LoginContainerProps) {
  // Transferred Parameters
  const [auth, setAuth] = useState<Auth>(getAuth());
  const [error, setError] = useState<MultiFactorError | undefined>();

  const display2FAValidation = (auth: Auth, error: MultiFactorError) => {
    setAuth(auth);
    setError(error);
    setIndex(1);
  };

  const [index, setIndex] = React.useState(0);
  const [routes] = React.useState([
    { key: 'first', title: 'Login' },
    { key: 'second', title: '2FA' },
  ]);

  const renderScene = SceneMap({
    first: () => {
      return FirstRoute({ auth, display2FAValidation, onSuccess });
    },
    second: () => {
      return SecondRoute({ auth, error });
    },
  });

  useEffect(() => {
    // console.log(`Rendering Login Container`);
  });

  return (
    <TabView
      navigationState={{ index, routes }}
      renderScene={renderScene}
      renderTabBar={() => null}
      onIndexChange={setIndex}
      initialLayout={initialLayout}
      style={{
        marginTop: StatusBar.currentHeight,
        height: '100%',
      }}
    />
  );
}

export default LoginContainer;
